import { ReactNode } from "react"
import { useRouter } from "next/router"

import Room from "layout/Room"
import useZoomButtons from "layout/ZoomButtons"
import Profile from "components/user/Profile"
import GoToMetaverseButton from "components/GoToMetaverseButton"
import { useHowdyGames } from "context/Game/Game"
import useHideOverlay from "hooks/useHideOverlay"

interface LayoutProps {
	children: ReactNode
}

const isLobby = (path: string) => path.replace(/\//, "") === ""

const Layout = ({ children: room }: LayoutProps) => {
	const { asPath } = useRouter()
	const { isModalOpen } = useHowdyGames()
	const shouldHideOverlay = useHideOverlay(asPath, isModalOpen)
	const { zoom, render: zoomButtons } = useZoomButtons(shouldHideOverlay, asPath)

	const className = `z-10 grid w-screen h-screen ${
		shouldHideOverlay ? "overflow-auto" : "overflow-hidden"
	} `

	return (
		<>
			{/* {!isLobby(asPath) && <FarmNav />} */}
			<main
				id="layout"
				className={className}
				style={{
					gridTemplateColumns: "repeat(1440, 1fr)",
					gridTemplateRows: "repeat(1080, 1fr)",
				}}
			>
				<Room
					room={room}
					zoom={zoom}
					shouldHideOverlay={shouldHideOverlay}
				/>
				<Profile shouldHideOverlay={shouldHideOverlay}/>
				{zoomButtons}
				{(asPath !== "/metaverse" && asPath !== "/") && !isModalOpen && <GoToMetaverseButton />}
			</main>
		</>
	)
}

export default Layout
